import { gql } from '@apollo/client'
import Head from 'next/head'

import { TagProps } from './types'

export interface MetaTagsProps {
  url: string | null
  tags: TagProps
}

export function MetaTags(props: MetaTagsProps) {
  const { url, tags } = props

  return (
    <Head>
      <title>{tags.title}</title>
      {url && <link rel="canonical" href={url} />}
      {tags.meta.map((metaTag) => (
        <meta key={metaTag.name || metaTag.property} {...metaTag} />
      ))}
      {tags.structuredData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(tags.structuredData) }}
        />
      )}
    </Head>
  )
}

MetaTags.fragments = {
  document: gql`
    fragment MetaTags_document on Document {
      url
      images {
        thumbor {
          thumbUrl(size: "1200x675")
        }
      }
      publisher {
        fullname
        url
        thumborAvatar {
          thumbUrl(size: "1200x675")
        }
      }
    }
  `,
}
